module.exports = __webpack_public_path__ + "img/company.12fc63d0.svg";